export default __webpack_public_path__ + "static/media/LOGO_OCSB.501e258e.png";